/**
 * Helper function for Forms
 * @module lib/forms
 */

/**
 * Replaces the options of the given `<select>` element with the provided `options` HTML.
 * It'll trigger an event if the value changed and can preseve the current value.
 * @param {HTMLSelectElement} select
 * @param {String} options
 * @param {Object} options
 * @param {boolean} options.preserveValue Whether to preserve the current value of the select.
 */
export function renderOptions(select, options, { preserveValue = true } = {}) {
  const value = select.value;
  select.innerHTML = options;
  if (preserveValue && select.querySelector(`[value="${value}"]`)) {
    select.value = value;
  } else {
    const firstOption = select.options[0];
    if (firstOption) {
      select.value = firstOption.value;
      // Only dispatch event if needed
      if (value != '') {
        const event = new CustomEvent('change', { bubbles: true });
        select.dispatchEvent(event);
      }
    }
  }
}

/**
 * Returns the `<option>` element currently selected on the given `<select>` element
 * @param {HTMLSelectElement} select
 */
export function selectedOption(select) {
  return select.options[select.selectedIndex];
}

/**
 * Checks the given `<input type="radio">`, dispatching a `change` event
 * @param {HTMLInputElement} radio
 */
export function checkRadio(radio) {
  if (!radio.checked) {
    radio.checked = true;
    // Trigger a change manually for other to pick up
    const event = new CustomEvent('change', { bubbles: true });
    radio.dispatchEvent(event);
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/forms.js